import { Navigate } from 'react-router-dom';

import Layout from '@/components/Layouts/Layout';

type ProtectedRouteProps = {
    isAuthenticated: boolean;
    hasPrivilege?: boolean;
    handleSetIsAuthenticated: (authenticated: boolean) => void;
    children: JSX.Element;
}

const ProtectedRoute = ({ isAuthenticated, hasPrivilege = true, handleSetIsAuthenticated, children }: ProtectedRouteProps) => {
    return (isAuthenticated && hasPrivilege) ?
        <Layout handleSetIsAuthenticated={handleSetIsAuthenticated}>
            {children}
        </Layout> :
        <Navigate to='/' replace />;
};

export default ProtectedRoute;
